import { ParametrosService } from './parametros.service';
import { ConfiguracoesProjeto } from './../../shared/model/configuracoes-projeto.model';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { NotaFiscalViewModel } from './../model/nota-fiscal.viewmodel';
import { GenericHttpService } from '../generic-http.service';
import { LoadingService } from '../../shared-layout/loading/loading.service';
import { StatusRequisicao } from '../model/status-requisicao';
import { Http, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { GerenciamentoFilename } from '../arquivo/filename-gerenciamento';
import { Observable } from 'rxjs';
import { FiltroRelatorioNotasFiscaisCidadao } from '../filter/filtro-relatorio-notas-fiscais-cidadao';

@Injectable()
export class NotaFiscalService {

  public urlBase: string;
  public urlBaseRelatorioNotasFiscais: string;

  public notasFiscaisChange = new Subject<NotaFiscalViewModel[]>();
  public notasFiscais: NotaFiscalViewModel[];
  public notasFicaisViewModel: NotaFiscalViewModel[];
  public notaFiscalError = '';
  public cpf: string;
  public configuracao: ConfiguracoesProjeto;

  public totalNotasParticipantes = 0;

  constructor(private readonly genericHttpService: GenericHttpService<NotaFiscalViewModel>,
    private readonly parametrosService: ParametrosService,
    private readonly loadingService: LoadingService,
    private readonly http: Http
  ) {
    this.configuracao = this.parametrosService.getConfiguracao();
    this.urlBase = this.configuracao.uri + 'notas-fiscais/';
    this.urlBaseRelatorioNotasFiscais = this.configuracao.uri + 'relatorio-notas-fiscais-cidadao/';
  }

  obterNotasFiscaisParticipantes(objFiltro) {
    this.loadingService.exibirLoading(null);
    const api = `listagem-notas/`;
    this.genericHttpService.getAllParam(this.urlBase + api, objFiltro).subscribe(
      (data: any) => {
        this.notasFiscais = <NotaFiscalViewModel[]>data.list; 
        this.totalNotasParticipantes = data.totalCount;   
        this.notasFiscaisChange.next(this.notasFiscais);
      },
      (error: any) => {
        this.notasFiscais = [];
        this.totalNotasParticipantes = 0;
        
        // Apresenta a mensagem de erro para o usuário.
        let erro = error as StatusRequisicao;
        this.notaFiscalError = error.motivo;

        this.notasFiscaisChange.next(this.notasFiscais);
        this.loadingService.esconderLoading();
      },
      () => {
        this.loadingService.esconderLoading();
      }
    );
  }

  public downloadRelatorioNotaFiscal(filtro: FiltroRelatorioNotasFiscaisCidadao) {

    const url = this.urlBaseRelatorioNotasFiscais.concat(`relatorio`);
    const requestOptions = new RequestOptions({ headers : this.getHeaders(), responseType : ResponseContentType.Blob});

    this.loadingService.exibirLoading(null);
    
    return this.http        
      .post(url, filtro, requestOptions)
      .map(
        (res) => {

          this.loadingService.esconderLoading();

        return {
          filename: GerenciamentoFilename.ObterBasicFileName(res),
          data: res.blob()
        };

      })
      .catch(this.handleError);
    }

    public handleError = (error: Response) => {
        this.loadingService.esconderLoading();           
        return Observable.throw(error.json());
    };

    private getHeaders(): Headers {
        
        const headers = new Headers();
        headers.append('Authorization', 'Bearer '  + localStorage.getItem("authorizationData"));
        headers.append('Accept', 'application/pdf, application/csv, application/json, */*');
        headers.append('Npb', 'true');
        headers.append('responseType', 'blob');
        headers.append('observe', 'response');            
        return headers;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/service/nota-fiscal.service.ts